import Device from '../../../../../constants/deviceSizes';
import { small } from '../../../../../constants/fonts';
import { appConfig } from '../../../../../config/customization';

export default {
  container: {
    height: '100%',
    width: '100%'
  },
  addAccount: {
    [Device.tablet_mobile]: {
      fontSize: small,
      padding: '6px 15px'
    }
  },
  spinnerContainer: {
    position: 'fixed',
    bottom: 0,
    padding: 5,
    backgroundColor: appConfig.colors.lightGray,
    width: 'calc(100% - 260px)',
    [Device.tablet_mobile]: {
      width: '100%'
    }
  }
};
